import { render } from "./DaemonConfigList.vue?vue&type=template&id=19b38180&scoped=true"
import script from "./DaemonConfigList.vue?vue&type=script&lang=js"
export * from "./DaemonConfigList.vue?vue&type=script&lang=js"

import "./DaemonConfigList.vue?vue&type=style&index=0&id=19b38180&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b38180"]])

export default __exports__